import React from "react";

const LatestAnnouncementIcon = ({ cls }) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cls}
    >
      <g clipPath="url(#clip0_4640_57962)">
        <path
          d="M12 10V25.0837C11.9999 25.2482 11.9592 25.4101 11.8816 25.5551C11.804 25.7001 11.6918 25.8237 11.555 25.915L10.18 26.8312C10.0466 26.9202 9.89383 26.9757 9.7345 26.9932C9.57516 27.0107 9.41394 26.9897 9.26445 26.9319C9.11495 26.874 8.98154 26.7811 8.87548 26.6609C8.76941 26.5407 8.6938 26.3968 8.655 26.2412L7 20"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <path
          d="M27 25C27 25.1904 26.9455 25.3769 26.8431 25.5375C26.7407 25.698 26.5946 25.826 26.4219 25.9064C26.2493 25.9867 26.0573 26.0161 25.8685 25.9911C25.6797 25.966 25.502 25.8876 25.3562 25.765C18.8062 20.27 12 20 12 20H7C5.67392 20 4.40215 19.4732 3.46447 18.5355C2.52678 17.5978 2 16.3261 2 15C2 13.6739 2.52678 12.4021 3.46447 11.4644C4.40215 10.5268 5.67392 9.99998 7 9.99998H12C12 9.99998 18.8062 9.72998 25.3562 4.23623C25.5019 4.1137 25.6795 4.03529 25.8682 4.01019C26.0568 3.9851 26.2488 4.01438 26.4214 4.09458C26.594 4.17478 26.7401 4.30258 26.8426 4.46296C26.9451 4.62334 26.9997 4.80965 27 4.99998V25Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4640_57962">
          <rect
            width="32"
            height="32"
            fill="currentColor"
            transform="matrix(-1 0 0 1 32 0)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default LatestAnnouncementIcon;
